import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';import { MatDialog } from '@angular/material/dialog';
import { AddEditDigiManagerComponent } from './add-edit-digi-manager/add-edit-digi-manager.component';
import { DigiServiceService } from '../services/digi-service.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-digi-manager',
  templateUrl: './digi-manager.component.html',
  styleUrls: ['./digi-manager.component.scss']
})
export class DigiManagerComponent implements OnInit {
  displayedColumns: string[] = ['digiId', 'deviceId', 'fuelType', 'capacity', 'status', 'actions'];
  dataSource!: MatTableDataSource<any>;

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  constructor(private dialog: MatDialog,private digiDashbioard: DigiServiceService) { }

  ngOnInit() {
    this.getDigiData();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
getDigiData(){
this.digiDashbioard.getGenerators().subscribe(res=>{
  console.log("generator data",res)

  if(res.status){
    this.dataSource = new MatTableDataSource(res.result);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
})
}
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  openAddEdit(action,data){
    const dialogRef = this.dialog.open(AddEditDigiManagerComponent, {
      width: '80%',
      height: '95%',
      data: { action: action, data: data }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getDigiData();
      }
    });
    
  }


  
  deleteDigi(digiid: any,deviceid:any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4CAF50',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.digiDashbioard.deleteGenerators({generatorId:digiid,deviceId:deviceid}).subscribe(res=>{    
          if(res.status){
            Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
            this.getDigiData();
          }        

        }); 
      }
    });
    
   
  }
}
